<template>
  <p class="pl_copy100">
    <slot></slot>
  </p>
</template>
